import { createReducer, on } from '@ngrx/store';
import { Testadapter, adapter, initialState, initialTestItemState } from './data.model';
import * as DataActions from './data.actions';

export const dataReducer = createReducer(
  initialState,
  on(DataActions.loadLocalData, (state, { data }) => adapter.setAll(data, state))
);


export const testReducer = createReducer(
  initialTestItemState,
  on(DataActions.loadLocalTest, (state, { test }) => Testadapter.setAll(test, state))
);
